import { dbGet, dbSet } from './db';

const KEY = 'request.queue';
const ID_MAP_KEY = 'request.idmap';
let flushing = false;

const makeId = () => `offline_${Date.now()}_${Math.random().toString(36).slice(2)}`;

export async function enqueueRequest(request = {}) {
  const queue = await dbGet(KEY, []);
  const item = {
    id: request.id || makeId(),
    createdAt: Date.now(),
    attempts: 0,
    ...request,
  };
  queue.push(item);
  await dbSet(KEY, queue);
  return item;
}

export const getQueuedRequests = () => dbGet(KEY, []);

const extractAttempt = (response) => {
  const payload = response?.data?.data ?? response?.data ?? null;
  return payload?.attempt || (payload?._id ? payload : null);
};

const resolveMappedUrl = (url, localAttemptId, idMap) => {
  const serverAttemptId = localAttemptId ? idMap?.[String(localAttemptId)] : '';
  if (!serverAttemptId || !localAttemptId) return url;
  return String(url || '').replace(String(localAttemptId), String(serverAttemptId));
};

export async function flushQueuedRequests(axios) {
  if (flushing || !axios) return { flushed: 0, pending: (await dbGet(KEY, [])).length };
  flushing = true;
  const queue = await dbGet(KEY, []);
  const idMap = (await dbGet(ID_MAP_KEY, {})) || {};
  let flushed = 0;
  const remaining = [];

  try {
    for (let index = 0; index < queue.length; index += 1) {
      const item = queue[index];
      try {
        const response = await axios.request({
          method: item.method || 'post',
          url: resolveMappedUrl(item.url, item.localAttemptId, idMap),
          data: item.data,
          params: item.params,
          headers: item.headers,
        });

        if (item.kind === 'assessment-start' && item.localAttemptId) {
          const attempt = extractAttempt(response);
          if (attempt?._id) {
            idMap[String(item.localAttemptId)] = String(attempt._id);
            await dbSet(ID_MAP_KEY, idMap);
            if (typeof window !== 'undefined') {
              window.dispatchEvent(new CustomEvent('flc:offline-assessment-server-attempt', {
                detail: { localAttemptId: item.localAttemptId, attempt },
              }));
            }
          }
        }

        flushed += 1;
      } catch (error) {
        const status = Number(error?.response?.status || 0);
        const retryable = !status || status >= 500 || status === 408 || status === 429 || status === 401;
        if (retryable) {
          remaining.push({ ...item, attempts: Number(item.attempts || 0) + 1, lastErrorAt: Date.now() });
          remaining.push(...queue.slice(index + 1));
          break;
        }
        // A server-side validation conflict should not block newer offline events forever.
        console.warn('[mobile-offline] dropping non-retryable queued request', item.url, status);
      }
    }
  } finally {
    await dbSet(KEY, remaining);
    flushing = false;
  }

  return { flushed, pending: remaining.length };
}
